import { render } from "./FeaturedArtists.vue?vue&type=template&id=27cccc72&scoped=true"
import script from "./FeaturedArtists.vue?vue&type=script&lang=js"
export * from "./FeaturedArtists.vue?vue&type=script&lang=js"

import "./FeaturedArtists.vue?vue&type=style&index=0&id=27cccc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cccc72"]])

export default __exports__